

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {namespace} from "vuex-class";

  import {IAuthUserData} from "@/store/modules/authModule";
  import {UrlHelper} from "@/helpers/UrlHelper";
  import UProCouponDialog from "@/components/user/promotions/UProCouponDialog.vue";
  import CreateButton from "@/components/shared/CreateButton.vue";
  import {IOrderPromotion} from "@/model/Order/orderInterfaces";
  import {IPromotion} from "@/model/Promotions/IPromotion";
  import PromotionOriginIcon from "@/components/promotion/widget/PromotionOriginIcon.vue";
  import Datim from "@/components/shared/Datim.vue";
  import OrderChip from "@/components/shared/chips/OrderChip.vue";
  import LinkChip from "@/components/shared/chips/LinkChip.vue";
  import UserSearch from "@/components/user/widget/UserSearch.vue";
  import UserNav from "@/components/user/widget/UserNav.vue";
  import {IShortUser} from "@/model/shortInterfaces";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
  import {BoListPanel, BoPanel} from "bonomo";

  const userModule = namespace("userModule");
  const usersPromotionModule = namespace("usersPromotionModule");
  const authModule = namespace("authModule");

  @Component({
    components: {
      BoPanel,
      BoListPanel,
      UProCouponDialog,
      CreateButton,
      PromotionOriginIcon,
      Datim,
      OrderChip,
      LinkChip,
      UserSearch,
      UserNav,
    }
  })
  export default class UserPromotions extends Vue {

    @Prop()
    protected userId!: number;

    @userModule.Getter('shortUser')
    protected user!: IAuthUserData;
    @usersPromotionModule.Getter('usersUsedPromotions')
    protected usedPromotions!: IOrderPromotion[];
    @usersPromotionModule.Getter('usersCoupons')
    protected coupons!: IPromotion[];
    @authModule.Getter('userData')
    protected authUser!: IAuthUserData;

    @userModule.Action('fetchShortUser')
    protected fetchShortUser!: (userId: number) => Promise<any>;
    @usersPromotionModule.Action('fetchUsedPromotions')
    protected fetchUsedPromotions!: (userId: number) => Promise<any>;
    @usersPromotionModule.Action('fetchCoupons')
    protected fetchCoupons!: (userId: number) => Promise<any>;

    protected UrlHelper: UrlHelper = UrlHelper;

    protected get usedPromotionsHeaders(): BetterDataTableHeader[] {
      return [
        { text: this.$t('orders.order.title'), align: 'start', sortable: true, value: 'order_id' },
        { text: this.$t('orders.promotion.promo_code'), align: 'start', value: 'promo_code' },
        { text: this.$t('orders.promotion.type'), align: 'start', value: 'type' },
        { text: this.$t('orders.promotion.value'), align: 'start', value: 'value' },
        // { text: this.$t('orders.promotion.value_type'), align: 'start', value: 'value_type' },
        { text: this.$t('users.promotions.discount'), align: 'start', value: 'discount' },
        { text: this.$t('common.when'), align: 'start', sortable: true, value: 'created_at' },
        { text: '', value: 'visibility' },
      ];
    }
    protected get couponsHeaders(): BetterDataTableHeader[] {
      return [
        { text: this.$t('orders.promotion.promo_code'), align: 'start', value: 'promo_code' },
        { text: this.$t('orders.promotion.type'), align: 'start', value: 'type' },
        { text: this.$t('orders.promotion.value'), align: 'start', value: 'value' },
        { text: this.$t('common.createdAt'), align: 'start', value: 'created_at' },
        { text: this.$t('common.expiresAt'), align: 'start', value: 'expiration_date' },
        // { text: this.$t('orders.promotion.active'), align: 'start', value: 'active' },
        // { text: this.$t('orders.promotion.value_type'), align: 'start', value: 'value_type' },
        { text: '', value: 'visibility' },
      ];
    }
    protected loading: boolean = false;

    get isSelf() {
      return '' + this.userId === '' + this.authUser.id;
    }

    protected getPromotion(item: IOrderPromotion) {
      return item.promotion || {};
    }

    protected onGotoUser(user: IShortUser) {
      if (user.id != this.userId) {
        this.$router.push({name: 'userPromotions', params: {userId: ''+user.id}});
      }
    }

    protected onCreate() {
      this.$uiBus.emit('u-pro-coupon.show', this.user);
    }

    protected onCouponCreated() {
      this.fetchCoupons(this.userId);
    }

    private loadData() {
      this.fetchShortUser(this.userId);
      this.fetchUsedPromotions(this.userId);
      this.fetchCoupons(this.userId);
    }

  }
